<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card header="Asistencia">
          <b-row class="form-group" v-if="profile_user_code !== constants.PROVEEDOR">
            <b-col cols="6">
              <div class="alert alert-info">
                <h5>Tarifas</h5>
                <form class="form-row">
                  <div class="form-group col-md-4">
                    <label>Tarifario diario:</label>
                    <input type="number" class="form-control" v-model="pricing" :disabled="disabled_month"/>
                  </div>
                  <div class="form-group col-md-4">
                    <label>Tarifario mantenimiento:</label>
                    <input type="number" class="form-control" v-model="pricing_mantto" :disabled="disabled_month"/>
                  </div>
                  <div class="form-group col-md-4">
                    <label>App Carcool:</label>
                    <input type="number" class="form-control" v-model="pricing_app" :disabled="disabled_month"/>
                  </div>
                </form>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="pull-left">
                <input type="text" class="form-control" v-model="search" placeholder="Filtrar"/>
              </div>
              <div class="pull-right">
                <!-- <b-form> -->
                <date-picker
                  v-model="month"
                  lang="es"
                  type="month"
                  placeholder="Hasta"
                  format="MM/YYYY"
                  @change="setMonth"
                ></date-picker>&nbsp;
                <!-- <input type="submit" class="btn btn-primary" value="Buscar"/>&nbsp; -->
                <template v-if="profile_user_code !== constants.PROVEEDOR && !disabled_month">
                  <button class="btn btn-success" @click="saveMonthlyRatio(false)"><i class="fa fa-money"></i> Guardar
                  </button>&nbsp;
                  <button class="btn btn-success" @click="saveMonthlyRatio(true)"><i class="fa fa-money"></i> Liquidar
                    mes
                  </button>
                </template>
                <!-- </b-form> -->
              </div>
            </b-col>
          </b-row>

          <b-row v-if="loading">
            <b-col cols="12">
              <div class="fa-2x center">
                <span class="fa fa-spinner fa-spin"></span>
              </div>
            </b-col>
          </b-row>

          <div class="table-responsive" v-if="!loading">
            <br>
            <div v-for="(provider, p) in filteredProviders" :key="p">
              <table v-if="provider.trucks.length" class="table table-bordered table-sm">
                <thead>
                <tr>
                  <th :colspan="days.length + 11">{{provider.name}} [{{provider.trucks.length}} camiones]</th>
                </tr>
                <tr>
                  <th :colspan="days.length + 11">TOTAL A LIQUIDAR: {{provider.payment}}</th>
                </tr>
                <tr>
                  <th>PLACA</th>
                  <th>DIAS</th>
                  <th>RQS</th>
                  <th>RATIO</th>
                  <th>MANTTO</th>
                  <th>VARIABLE</th>
                  <th>FIJO ASISTENCIA</th>
                  <th>COMBUSTIBLE</th>
                  <th>APP</th>
                  <th>DESCUENTOS</th>
                  <th>TOTAL</th>
                  <th
                    v-for="(day, d) in days"
                    :key="d"
                    scope="col"
                    align="center"
                  >{{day.locale('es').format("DD/MM")}}
                    <!-- <span v-if="p == 0">
                        <template v-if="profile_user_code !== constants.PROVEEDOR">
                        <br>
                        <i class="fa fa-save" @click="saveAssistance(day)" v-b-tooltip.hover title="Guardar"/> 
                        | 
                        <i class="fa fa-calendar" @click="setFactor(day)" v-b-tooltip.hover
                          title="Registrar asistencia"/>
                        </template>
                      </span> -->
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(truck, t) in provider.trucks" :key="t">
                  <td>{{ truck.plate }}</td>
                  <td>{{getDays(truck)}}</td>
                  <td>
                    {{truck.total_rqs}}
                  </td>
                  <td>{{getRatio(truck)}}</td>
                  <td>
                    <template v-if="profile_user_code === constants.PROVEEDOR">
                      <input type="checkbox" v-model="truck.mantto"
                             :disabled="true"/>
                    </template>
                    <template v-else>
                      <input type="checkbox" v-model="truck.mantto"
                             :disabled="disabled_month"/>
                    </template>
                  </td>
                  <td v-b-tooltip.hover :title="getInfo(provider, truck.id)">
                    {{ getVariable(truck, provider) }}
                  </td>
                  <td>{{ getFixed(truck) }}</td>
                  <td>
                    <template v-if="profile_user_code === constants.PROVEEDOR">
                      <input type="number" v-model="truck.fuel" class="form-control"
                             :readonly="true"/>
                    </template>
                    <template v-else>
                      <input type="number" v-model="truck.fuel" class="form-control" :disabled="disabled_month"/>
                    </template>
                  </td>
                  <td>{{ getApp(truck) }}</td>
                  <td>{{ truck.discounts }}</td>
                  <td>
                    {{ getBilling(truck, provider) }}
                  </td>
                  <td v-for="(day, d) in days" :key="d">
                    <template v-if="profile_user_code === constants.PROVEEDOR">
                      <input type="number" style="width: 75px;" placeholder=""
                             v-model="assistances[day.format('YYYY-MM-DD')][truck.id].factor" step="0.1" min="0" max="1"
                             class="form-control form-control-sm" :readonly="true"/>
                      <i class="fa fa-eye" v-b-tooltip.hover title="Ver"
                         @click="openModal(assistances[day.format('YYYY-MM-DD')][truck.id].factor,
                         day.format('YYYY-MM-DD'), truck.id, assistances[day.format('YYYY-MM-DD')][truck.id].subject)"/>
                    </template>
                    <template v-else>
                      <h5>{{assistances[day.format('YYYY-MM-DD')][truck.id].factor || '--'}}</h5>
                      <button @click="openHours(day, assistances[day.format('YYYY-MM-DD')][truck.id], truck)" class="btn btn-primary btn-sm">Registro</button>  
                      <!-- <input type="number" style="width: 75px;" placeholder=""
                             @change="openModal(assistances[day.format('YYYY-MM-DD')][truck.id].factor,
                         day.format('YYYY-MM-DD'), truck.id, assistances[day.format('YYYY-MM-DD')][truck.id].subject)"
                             v-model="assistances[day.format('YYYY-MM-DD')][truck.id].factor" step="0.1" min="0" max="1"
                             class="form-control form-control-sm" :disabled="disabled_month"/>
                      <i v-if="assistances[day.format('YYYY-MM-DD')][truck.id].factor < 1 &&
                      assistances[day.format('YYYY-MM-DD')][truck.id].factor >= 0 &&
                       assistances[day.format('YYYY-MM-DD')][truck.id].factor !== ''" class="fa fa-eye"
                         v-b-tooltip.hover title="Ver"
                         @click="openModal(assistances[day.format('YYYY-MM-DD')][truck.id].factor,
                         day.format('YYYY-MM-DD'), truck.id, assistances[day.format('YYYY-MM-DD')][truck.id].subject)"/> -->
                    </template>
                  </td>
                </tr>
                </tbody>
              </table>
              <div v-else class="alert alert-warning">
                <h5>{{provider.name}}</h5>
                Proveedor sin camiones asociados
              </div>
            </div>
          </div>
        </b-card>
      </b-col>

      <!-- <Modal :showModal="showModal" :truck="truck_id_modal" :date="assistancedate" :data-test="dataTest"
             :disabled_month="disabled_month" @onCancelModal="deleteSubject"
             @close="showModal =false" @onCloseModal="assignSubject"></Modal> -->
      <ModalHours :showModal="showModalHours" :truck="truck" :day="day" :assistance="assistance" @close="showModalHours=false" @saveAssistance="saveAssistance"></ModalHours>
      <div v-if="showModal || showModalHours" class="modal-backdrop fade show"></div>
    </b-row>
  </div>
</template>

<script>
  import api from '@/helpers/api'
  import moment from 'moment'
  import {mapGetters} from 'vuex'
  // import Modal from "./Modal";
  import ModalHours from "./ModalHours";
  import constants from '@/constants'

  export default {
    components: {ModalHours},
    name: 'Assistance',
    data() {
      return {
        providers: [{
          trucks: []
        }],
        month: moment(),
        register_date: '',
        startDay: moment().startOf('month'),
        endDay: moment().endOf('month'),
        days: [],
        assistance: {
          hours: []
        },
        day: {},
        truck: '',
        assistances: {},
        search: '',
        loading: true,
        pricing: 80,
        pricing_mantto: 80,
        pricing_app: 1.5,
        // fact: {},
        disabled_month: false,
        ratio: {},
        profile_user_code: null,
        showModal: false,
        showModalHours: false,
        truck_id_modal: null,
        assistancedate: null,
        reason: null,
        dataTest: {
          reason: null
        },
        constants
      }
    },
    computed: {
      ...mapGetters(
        {'user': 'user/user'}
      ),
      filteredProviders() {
        return this.providers.filter(provider => {
          let condition = true
          let text = this.search.toLowerCase()
          if (text) {
            condition = provider.name.toLowerCase().includes(text) ||
              (provider.trucks && provider.trucks.map(t => t.plate.toLowerCase()).join(' ').includes(text))
          }
          return condition
        })
      },
    },
    mounted() {
      // this.getTrucks()
      this.getMonthlyRatio()
      this.profileUser()
    },
    methods: {
      getInfo(provider, truck_id) {
        let data = {}
        let text = ''
        if (this.ratio && this.ratio.sold_out) {
          let rt = this.ratio.ratio_trucks.find(rt => rt.truck_id == truck_id)
          data = {
            ratio_limit: rt.ratio_provider.ratio_limit,
            lower: rt.ratio_provider.lower,
            higher: rt.ratio_provider.higher
          }
        } else {
          data = {ratio_limit: provider.ratio_limit, lower: provider.lower, higher: provider.higher}
        }

        text = `Ratio mayor o igual a ${data.ratio_limit} paga USD ${data.higher}. Menor a ${data.ratio_limit} paga USD ${data.lower}`
        return text
      },
      getApp(truck) {
        truck.app = (truck.total_rqs * this.pricing_app).toFixed(1)
        return truck.app
      },
      setMonth() {
        this.month = moment(this.month)
        this.getMonthlyRatio()
      },
      getRqsCount(truck_id) {
        return Object.values(this.assistances).reduce((t, assis) => (assis[truck_id].total_rqs || 0) + t, 0)
      },
      getDiscounts(truck_id) {
        return Object.values(this.assistances).reduce((t, assis) => (assis[truck_id].discounts || 0) + t, 0)
      },
      getDays(truck) {
        truck.days = (Object.values(this.assistances).reduce((t, assis) => (parseFloat(assis[truck.id].factor) || 0) + t, 0)).toFixed(1)
        return truck.days
      },
      getRatio(truck) {
        let days = this.getDays(truck)
        truck.ratio = days > 0 ? (truck.total_rqs / days).toFixed(1) : 0
        return truck.ratio
      },
      getBilling(truck, provider) {
        let days = this.getDays(truck)
        let total_rqs = truck.total_rqs
        let mantto = truck.mantto
        let app = this.getApp(truck)
        let fuel = truck.fuel
        let discounts = truck.discounts

        let billing = 0
        let ratio = 0

        if (days > 0) {
          ratio = (total_rqs / days).toFixed(1)
        }

        if (this.ratio && this.ratio.sold_out) {
          // Calculo con data liquidada
          let ratio_provider = this.ratio.ratio_trucks.find(r => r.truck_id == truck.id).ratio_provider

          if (ratio >= ratio_provider.ratio_limit) {
            billing = total_rqs * ratio_provider.higher + days * this.ratio.pricing
          } else {
            billing = total_rqs * ratio_provider.lower + days * this.ratio.pricing
          }

          if (mantto) {
            billing += parseFloat(this.ratio.pricing_mantto)
          }

          billing -= parseFloat(app)

        } else {
          // Calculo con data aun no liquidada
          if (ratio >= provider.ratio_limit) {
            billing = total_rqs * provider.higher + days * this.pricing
          } else {
            billing = total_rqs * provider.lower + days * this.pricing
          }

          if (mantto) {
            billing += parseFloat(this.pricing_mantto)
          }

          billing -= parseFloat(app)
        }

        if (fuel) {
          billing -= truck.fuel
        }

        if (discounts) {
          billing -= truck.discounts
        }

        provider.payment = provider.trucks.reduce((acum, truck) => (acum + parseFloat(truck.billing)), 0)

        truck.billing = billing
        return billing.toFixed(1)
      },
      getFixed(truck) {
        let days = this.getDays(truck)
        if (this.ratio && this.ratio.sold_out) {
          truck.fixed = days * this.ratio.pricing
        } else {
          truck.fixed = days * this.pricing
        }
        return truck.fixed
      },
      getVariable(truck, provider) {
        let variable = 0
        let ratio = 0
        let days = this.getDays(truck)
        if (days > 0) {
          ratio = (truck.total_rqs / days).toFixed(1)
        }

        if (this.ratio && this.ratio.sold_out) {
          // Calculo con data liquidada
          let ratio_provider = this.ratio.ratio_trucks.find(r => r.truck_id == truck.id).ratio_provider

          if (ratio >= ratio_provider.ratio_limit) {
            truck.variable = truck.total_rqs * ratio_provider.higher
          } else {
            truck.variable = truck.total_rqs * ratio_provider.lower
          }
        } else {
          // Calculo con data aun no liquidada
          if (ratio >= provider.ratio_limit) {
            truck.variable = truck.total_rqs * provider.higher
          } else {
            truck.variable = truck.total_rqs * provider.lower
          }

        }
        truck.variable = truck.variable.toFixed(1)
        return truck.variable
      },
      getMonthlyRatio() {

        let data = {
          start_month: moment(this.month).format('YYYY-MM-01'),
          end_month: moment(this.month).format('YYYY-MM-01')
        }

        api.post('/monthly_ratio', data).then(response => {
          //response.ratios
          this.ratio = response.ratios[0]
          this.disabled_month = this.ratio && this.ratio.sold_out ? true : false
          if (this.ratio) {
            this.pricing = this.ratio.pricing
            this.pricing_mantto = this.ratio.pricing_mantto
            this.pricing_app = this.ratio.pricing_app
          }
          this.getAssistances()
        })
      },
      getAssistances() {

        let {month} = this;
        month = moment(month)

        this.loading = true
        //aca
        api.post('/month_resume', {month}).then(response => {
          this.providers = response.providers
          //console.log(this.providers)

          let fuel = 0
          let mantto = 0
          let app = 0

          this.providers.map(provider => {
            provider.trucks.map(t => {
              if (this.ratio) {
                fuel = this.ratio.ratio_trucks.find(rt => rt.truck_id == t.id) ? this.ratio.ratio_trucks.find(rt => rt.truck_id == t.id).fuel : 0
                mantto = this.ratio.ratio_trucks.find(rt => rt.truck_id == t.id) ? this.ratio.ratio_trucks.find(rt => rt.truck_id == t.id).mantto : 0
                app = this.ratio.ratio_trucks.find(rt => rt.truck_id == t.id) ? this.ratio.ratio_trucks.find(rt => rt.truck_id == t.id).app : 0
              }
              this.$set(t, 'fuel', fuel)
              this.$set(t, 'mantto', mantto)
              this.$set(t, 'app', app)
            })
          })

          //this.$set(t, 'days', days)
          //this.$set(t, 'total_rqs', total_rqs)
          //this.$set(t, 'discounts', discounts)


          // this.$set(t, 'ratio', this.getRatio(t))
          // this.$set(t, 'fixed', this.getFixed(t))
          // this.$set(t, 'variable', this.getVariable(t, p))

          //let billing = this.getBilling(t, p)
          //this.$set(t, 'billing', billing)
          //p.payment += parseFloat(billing)


          // ASISTENCIA
          let day = moment(month).startOf('month')
          let end_day = moment(month).endOf('month')
          this.days = []
          this.assistances = {}

          // this.fact[moment(month).format('YYYY-MM')] = {}

          while (day <= end_day) {
            this.assistances[moment(day).format('YYYY-MM-DD')] = {}
            this.providers.map(p => {
              p.trucks.map(t => {
                this.assistances[moment(day).format('YYYY-MM-DD')][t.id] = {}
              })
            })
            this.days.push(day);
            day = day.clone().add(1, "d").startOf('day');
          }
        })

        let data = {
          start: moment(month).startOf('month').format('YYYY-MM-DD 00:00:00'),
          end: moment(month).endOf('month').format('YYYY-MM-DD 23:59:59')
        }

        api.post('/assistances', data).then(response => {
          // this.assistances =  {}
          this.loading = false
          let assistance_aux = {}
          Object.entries(response.assistances).map((assis) => {
            let date = assis[0]
            let aux_assis = assis[1]
            assistance_aux[date] = {}

            this.providers.map(p => {
              p.trucks.map(t => {

                assistance_aux[date][t.id] = {}
                if (aux_assis[t.id]) {
                  assistance_aux[date][t.id] = aux_assis[t.id]
                } else {
                  assistance_aux[date][t.id] = {factor: '', total_rqs: 0, subject: '', discounts: 0}
                }
              })
            })
          })
          this.assistances = assistance_aux

          this.providers.map(p => {

            // this.$set(p, 'trucks', p.trucks)
            this.$set(p, 'payment', 0)
            p.trucks.map(t => {

              let days = this.getDays(t)
              //let total_rqs = this.getRqsCount(t.id)
              //let discounts = this.getDiscounts(t.id)

              // let billing = this.getBilling(t.id, days, rqs, ratio, p)
              let fuel = 0
              let mantto = 0
              let app = 0

              // if (this.ratio) {
              //   fuel = this.ratio.ratio_trucks.find(rt => rt.truck_id == t.id) ? this.ratio.ratio_trucks.find(rt => rt.truck_id == t.id).fuel : 0
              //   mantto = this.ratio.ratio_trucks.find(rt => rt.truck_id == t.id) ? this.ratio.ratio_trucks.find(rt => rt.truck_id == t.id).mantto : 0
              //   app = this.ratio.ratio_trucks.find(rt => rt.truck_id == t.id) ? this.ratio.ratio_trucks.find(rt => rt.truck_id == t.id).app : 0
              // }

              this.$set(t, 'days', days)
              //this.$set(t, 'total_rqs', total_rqs)
              // this.$set(t, 'discounts', discounts)

              //this.$set(t, 'fuel', fuel)
              //this.$set(t, 'mantto', mantto)
              //this.$set(t, 'app', app)

              this.$set(t, 'ratio', this.getRatio(t))
              this.$set(t, 'fixed', this.getFixed(t))
              this.$set(t, 'variable', this.getVariable(t, p))
              let billing = this.getBilling(t, p)
              this.$set(t, 'billing', billing)
              p.payment += parseFloat(billing)
              return t
            })
            return p
          })
        })
      },
      saveMonthlyRatio(sold_out) {
        let data = {}
        let flag = true
        if (sold_out) {
          if (!confirm(`¿Seguro desea liquidar el mes ${moment(this.month).format('MM-YYYY')}, una vez liquidado no podrá realizar modificaciones?`)) {
            flag = false
          }
        }

        if (flag) {
          // data.ratios = this.fact[moment(this.month).format('YYYY-MM')]
          data.ratios = this.providers.map(p => p.trucks.map(t => {
            return {
              id: t.id,
              days: this.getDays(t),
              mantto: t.mantto,
              total_rqs: t.total_rqs,
              fuel: t.fuel,
              ratio: this.getRatio(t),
              fixed: t.fixed,
              variable: t.variable,
              discounts: t.discounts
            }
          }))

          data.pricing_mantto = this.pricing_mantto
          data.pricing_app = this.pricing_app
          data.pricing = this.pricing
          data.month = moment(this.month).format('YYYY-MM-01')
          data.sold_out = sold_out

          data.providers = this.providers.map(p => {
            return {provider_id: p.id, ratio_limit: p.ratio_limit, lower: p.lower, higher: p.higher, payment: p.payment}
          })
          // Revisar envio
          //console.log(data)
          // return
          api.post('/add_ratio', data).then(response => {

            if (sold_out)
              this.disabled_month = true

            this.$toastr.success('Asistencia mensual registrado.', 'Ratio', {
              positionClass: "toast-top-center",
              closeButton: true
            });
          })
        }
      },
      saveAssistance(assistance, factor) {
        // console.log(assistance.hours)
        // console.log(this.truck.id)
        // console.log(moment(this.day).format('YYYY-MM-DD'))
        // console.log(factor)
        // return
        let data = {
          date: moment(this.day).format('YYYY-MM-DD'),
          factor,
          hours: assistance.hours,
          truck_id: this.truck.id,
          subject: 'Probando'
        }

        api.put('/assistance', data).then(response => {
          // alert('Asistencia registrada')
          this.$toastr.success('Asistencia registrada', 'Asistencia', {
            positionClass: "toast-top-center",
            closeButton: true
          });
        })
      },
      setFactor(day) {
        let date = moment(day).format('YYYY-MM-DD')
        this.assistances[date] = {}//this.assistances[date]// ? this.assistances[date] : {}
        this.providers.map(p => {
          p.trucks.map(t => {
            // if(this.assistances[date][t.id] >= 0){
            //   console.log(this.assistances[date][t.id])
            // }
            this.assistances[date][t.id] = {}
            this.assistances[date][t.id].factor = (this.assistances[date][t.id].factor >= 0 ? this.assistances[date][t.id].factor : 1)
            this.assistances[date][t.id].subject = ''

            // console.log(this.assistances[date][t.id])
          })
        })
      },
      profileUser() {
        this.profile_user_code = this.user.role.code
      },
      openModal(factor, date, truck, subject) {
        if (factor < 1 && factor >= 0) {
          this.showModal = !this.showModal;
          this.assistancedate = date
          this.truck_id_modal = truck
          this.dataTest.reason = subject;
        }
      },
      assignSubject(fecha, truck, reason) {
        this.showModal = false
        this.assistances[fecha][truck].subject = reason
      },
      deleteSubject(fecha, truck) {
        this.showModal = false
        if (this.assistances[fecha][truck].subject === '' || this.assistances[fecha][truck].subject === null) {
          this.assistances[fecha][truck].factor = ''
          this.assistances[fecha][truck].subject = ''
        }
      },
      openHours(day, assistance, truck){
        this.day = day
        this.truck = truck
        this.assistance = {hours: []}
        if(!assistance.hours || !assistance.hours.length){
          let hour = moment(day).startOf('day')
          let end_hours = moment(day).endOf('day')
          this.hours = []
          
          while(hour <= end_hours){  
            let data = {
              hour: moment(hour).format('HH:mm'),
              code: ''
            }
            this.assistance.hours.push(data);
            
            hour = hour.clone().add(1, "hour")
          }
        } else {
          this.assistance = assistance
        }
        console.log(this.assistance)
        this.showModalHours = true
      }
    }
  }
</script>

<style>
  th span i {
    cursor: pointer;
  }
</style>
